import { setupHandleError } from 'error-logging!sofe';

export const handleError = setupHandleError('billing-ui');

export const customErrorMessages = {
  'Service item not found': 'The service item has been archived and cannot be used.',
  'User does not have access to all clients': 'The client has been archived and cannot be used.',
};
